import { enableScroll, stopScroll } from '../__utils/lockScroll';

const $ = jQuery.noConflict();

class LighboxVideo {
    constructor() {
        this.lightbox = $('.hero-homepage__lightbox');
        this.lightboxOpen = $('.hero-homepage__play-button');
        this.lightboxClose = $('.hero-homepage__lightbox-close');
        this.lightboxFile = $('.hero-homepage__lightbox-file');
    }
    init() {
        this.bindEvents();
    }
    bindEvents() {
        this.lightboxOpen.on('click', this.openLightbox.bind(this));
        this.lightboxClose.on('click', this.closeLightbox.bind(this));
    }
    openLightbox() {
        this.lightbox.addClass('visible');
        this.lightboxFile.get(0).play();
        stopScroll();
    }
    closeLightbox() {
        this.lightbox.removeClass('visible');
        this.lightboxFile.get(0).pause();
        enableScroll();
    }
}

export default new LighboxVideo();
